export default "__VITE_ASSET__Gsq6mMHp__"